import React from "react"
import { defaultMarkdownElements } from "#/services/markdown"
import type { BlockQuoteNode } from "../renderer/types"
import { ContentList } from "./content-item"

const backgroundColorToSolidColor: Record<string, "info" | "success"> = {
  info: "info",
  success: "success"
}

export function BlockQuoteContent({ content }: { content: BlockQuoteNode }) {
  const solidColor = content.backgroundColor ? backgroundColorToSolidColor[content.backgroundColor] : undefined
  const tileProps = solidColor ? { color: solidColor } : {}

  return (
    <defaultMarkdownElements.blockquote.component {...defaultMarkdownElements.blockquote.props} {...tileProps}>
      <ContentList contents={content.content} />
    </defaultMarkdownElements.blockquote.component>
  )
}
